'use client';
import { Spinner } from '../../components/ui/states';
import { useTranslation } from '../../lib/i18n';

/** The plugin's neutral activation state after a stored change: the values are durable, the live registry has
 *  not applied them yet. It is domain status, not an outcome toast, so it stays visible beside the surface that
 *  caused it. The live region is always present, so the appearance of the text is announced. */
export function PluginActivationPending({ pending }: { pending: boolean }) {
  const { t } = useTranslation();
  return (
    <span role="status" aria-live="polite" className="inline-flex items-center gap-1.5 text-meta text-warning">
      {pending ? <><Spinner size="sm" tone="" />{t.common.activationPending}</> : null}
    </span>
  );
}
